import { render, staticRenderFns } from "./operation-auth-confirm.vue?vue&type=template&id=051a2678"
import script from "./operation-auth-confirm.vue?vue&type=script&lang=js"
export * from "./operation-auth-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports